import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const View = {template: '<router-view></router-view>'}

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("./core/plugins/TitleRibbon/index"),
            children: [
                {
                    path: "/dashboard",
                    meta: {main_page: true},
                    name: "dashboard",
                    component: () => import("./core/plugins/TitleRibbon/Dashboard")
                },

                {
                    path: "/site",
                    name: "site.index",
                    component: () => import("@/view/pages/site/index"),
                    meta: {title: "سفارش طراحی سایت", has_ribbon: true},
                },
                {
                    path: "/seo",
                    name: "seo.index",
                    component: () => import("@/view/pages/site/seo"),
                    meta: {title: "سفارش سئو سایت", has_ribbon: true},
                },

                {
                    path: "/support",
                    name: "support.index",
                    component: () => import("@/view/pages/site/support"),
                    meta: {title: "سفارش پشتیبانی سایت", has_ribbon: true},
                },

                {
                    path: "/site/:id",
                    name: "site.edit",
                    props: true,
                    component: () => import("@/view/pages/site/Edit"),
                    meta: {title: "اصلاح سفارش سایت", has_ribbon: true},
                },

                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("@/view/pages/profile/Profile.vue"),
                    children: [
                        {
                            path: "my-profile",
                            name: "myProfile",
                            component: () => import("@/view/pages/profile/MyProfile.vue")
                        },
                    ]
                },
                {
                    path: "/tarefe",
                    name: "tarefe.list",
                    component: () => import("@/view/pages/tarefe/list"),
                    meta: {title: "لیست تعرفه ها", has_ribbon: true},
                },
                {
                    path: "/tarefe/create",
                    name: "tarefe.create",
                    component: () => import("@/view/pages/tarefe/create"),
                    meta: {title: "ایجاد تعرفه", has_ribbon: true},
                },
                {
                    path: "/admin/forms",
                    name: "admin.index",
                    component: () => import("@/view/pages/admin/requestsList"),
                    meta: {title: "لیست سفارش ها", has_ribbon: true},
                },
                {
                    path: "/orders/all",
                    name: "allOrder",
                    component: () => import("@/view/pages/site/allOrders.vue"),
                    meta: {title: "لیست سفارش های من", has_ribbon: true},
                },

            ]
        },

        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: () => import("@/view/pages/Dashboard.vue")
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("@/view/pages/profile/Profile.vue"),
                    children: [
                        {
                            path: "my-profile",
                            name: "myProfile",
                            component: () => import("@/view/pages/profile/MyProfile.vue")
                        },
                    ]
                },
            ]
        },


        //  ERRORS
        {
            path: "/custom-error",
            name: "error",
            component: () => import("@/view/pages/error/Error.vue"),
            children: [
                {
                    path: "error-1",
                    name: "error-1",
                    component: () => import("@/view/pages/error/Error-1.vue")
                },
                {
                    path: "error-2",
                    name: "error-2",
                    component: () => import("@/view/pages/error/Error-2.vue")
                },
                {
                    path: "error-3",
                    name: "error-3",
                    component: () => import("@/view/pages/error/Error-3.vue")
                },
                {
                    path: "error-4",
                    name: "error-4",
                    component: () => import("@/view/pages/error/Error-4.vue")
                },
                {
                    path: "error-5",
                    name: "error-5",
                    component: () => import("@/view/pages/error/Error-5.vue")
                },
                {
                    path: "error-6",
                    name: "error-6",
                    component: () => import("@/view/pages/error/Error-6.vue")
                }
            ]
        },


        //  404
        {
            path: "*",
            redirect: "/404"
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/view/pages/error/Error-1.vue")
        }
    ]
});
